import { Box, Container, Divider, Grid, IconButton, Typography } from '@material-ui/core'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    Edit as EditIcon, Search as SearchIcon
} from '@material-ui/icons'
import MUIDataTable from "mui-datatables"
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useHistory } from "react-router-dom"
import Select from '../../../components/Form/Select'
import DateField from '../../../components/Form/Date'
import ButtonUI from '../../../components/ui/ButtonUI'
import LoadingUI from '../../../components/ui/LoadingUI'
import PageTitle from '../../../components/ui/PageTitleUI'
import { useAuth } from '../../../hooks/auth'
import { InfoConference100Register } from '../../../interfaces/Mvm'
import MvmStatus from '../../../interfaces/MvmStatus'
import MvmApi from '../../../services/MvmApi'
import getDefaultGridOptions from '../../../utils/componentUtils'
import utilsDate from '../../../utils/Date'
import permissions from '../../../utils/Permissions'
import { useStyles } from './Style'
import * as Yup from 'yup'

const Register: React.FC = () => {
    const classes = useStyles()
    const history = useHistory()
    const [list, setList] = useState<any>([])
    const [loading, setLoading] = useState(true)
    const { user, hasPermission } = useAuth()
    const { t: tConference100 } = useTranslation("Conference100")
    const { t: tGeneral } = useTranslation("General")
    const { t: tMvm } = useTranslation("Mvm")
    const { t: tVal } = useTranslation("Validation")
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    useEffect(() => {
        if (!hasPermission(permissions.CONFERENCE.Add))
            history.push('/NoPermission')
    }, [history, user]);
    
    //Campos do Form
    interface IFormSearch {
        entranceDate?: Date | null;
        mvm?: any;
    }

    //Metodos do form:
    const { handleSubmit, reset, control, getValues, setValue, clearErrors, setError } = useForm<IFormSearch>({
        defaultValues: {
            entranceDate: null,
            mvm: {}
        }
    });

    const columns = [
        {
            name: 'mvmShedId',
            options: {
                display: false,
            }
        },        
        {
            name: 'mvmNumber',
            label: tConference100("mvmNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "left",
                    }),
                setCellProps: () => ({
                    align: "left"
                }),
            }
        },
        {
            name: 'submitDate',
            label: tMvm("submitDate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value)
                }
            }
        },
        {
            name: "vehiclePlateNumber",
            label: tMvm("vehiclePlateNumber"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                }),
            }
        },
        {
            name: "suppliers",
            label: tMvm("suppliers"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                })
            }
        },
        {
            name: "shed",
            label: tConference100("local"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'entranceDate',
            label: tMvm("entranceDate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value)
                }
            }
        },
        {
            name: 'exitDate',
            label: tMvm("exitDate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value)
                }
            }
        },
        {
            name: "volumeQuantity",
            label: tConference100("volumeQuantity"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                }),
            }
        },
        {
            name: "DEEM",
            label: tConference100("deem"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                }),
            }
        },
        {
            name: '',
            label: '',
            options: {
                sort: false,
                setCellProps: () => ({
                    align: "left"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <>
                            <Box display="flex">
                                <IconButton aria-label="Edit" color="primary" onClick={() => 
                                    history.push('/Conference100-InsertUpdate?MvmShedId=' + tableMeta.rowData[0])}>
                                    <EditIcon fontSize='small'/>                              
                                </IconButton>
                            </Box>
                        </>
                    );
                }
            }
        }
    ]

    const formValidation = async (data: any) => {
        var result = false
        clearErrors();

        try {
            const schema = Yup.object().shape({              
                entranceDate: Yup.date().nullable().typeError(tVal("formatDate"))
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            result = true
        }
        catch (err) {

            var errors: string[] = [];

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {

                    if (errors.filter(element => element.includes(error.message)).length == 0)
                        errors.push(error.message)

                    setError(error.path?.split('.')[0] as 
                    "entranceDate"
                    , { message: error.message });
                })
            }

            result = false;
        }

        return result
    }

    useEffect(() => {
        onSubmit({
            // entranceDate: '',
            mvmNumber: ''
        });
    }, []);

    const onSubmit = async (data: any) => {
        
        var validForm = await formValidation(data)
        if (!validForm)
            return;
        
        setLoading(true);
        const filtro: InfoConference100Register = {
            plantId: user.company.plantID,
            entranceDate: data?.entranceDate,
            mvmId: data?.mvm?.code,
            pageSize: rowsPerPage,
            pageIndex: page
        }

        MvmApi.searchConference100ToRegister(filtro)
            .then(result => {
                setList(result.items)
                setCount(result.totalCount)
            }).catch(() => {
                setList([]);
            }).finally(() => {
                setLoading(false);
            });
    };

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
        }
    })

    return (
        <Container maxWidth={false} component="main">
            <PageTitle title={tConference100("conference100RegisterTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(onSubmit)}  >

                        <Grid container spacing={1}>
                            <Grid item xs={4} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {tGeneral("search")}
                                </Typography>

                            </Grid>

                            <Grid item xs={8} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI onClick={() => reset()} startIcon={<BackspaceOutlinedIcon />}>{tGeneral("clean")}</ButtonUI>
                                <ButtonUI  type="submit" color="primary" startIcon={<SearchIcon />}>{tGeneral("search")}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={2}>
                                <DateField
                                    label={tMvm("entranceDate")} 
                                    name="entranceDate" 
                                    control={control} 
                                    InputLabelProps={{shrink:true}}
                                    fullWidth />                                
                            </Grid>
                            <Grid item xs={2}>
                                <Select
                                    label={tConference100('mvmNumber')} 
                                    name={'mvm'}
                                    control={control}
                                    searchFunction={(mvmNumber:string) => 
                                        MvmApi.searchMvmNumbersAutocomplete(
                                            user.company.companyID,
                                            mvmNumber, 
                                            [MvmStatus.FLAG_STATUS_PENDING_UNLOAD,
                                            MvmStatus.FLAG_STATUS_PENDING_FINISH_UNLOAD,
                                            MvmStatus.FLAG_STATUS_PENDING_LOAD,
                                            MvmStatus.FLAG_STATUS_PENDING_FINISH_LOAD,
                                            MvmStatus.FLAG_STATUS_PENDING_TRANSPORT_ORDER,
                                            MvmStatus.FLAG_STATUS_PENDING_BILLING,
                                            MvmStatus.FLAG_STATUS_PENDING_INVOICING,
                                            MvmStatus.FLAG_STATUS_PENDING_EXIT,
                                            MvmStatus.FLAG_STATUS_FINISHED])}
                                    style={{width: "100%", marginRight: 10}}
                                    allowEnterKey={false} />
                            </Grid>
                            
                        </Grid>
                        
                    </form>
                
                    {
                        loading ? <LoadingUI /> :
                        <>
                            <Divider style={{ marginTop: '10px' }} />
                            
                            <p>{tGeneral("totalCount")} {("00" + list.length).slice(-2)}</p>
                            
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={list}
                                    columns={columns}
                                    options={{
                                        ...getDefaultGridOptions(tGeneral),
                                        serverSide: true,
                                        pagination: true,
                                        sort: false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                        page,
                                        count,
                                        rowsPerPage,                                        
                                        onChangePage: (pageIndex) => { setPage(pageIndex) },
                                        onChangeRowsPerPage: (rowsPerPage) => { setPage(0); setRowsPerPage(rowsPerPage) },
                                        }}
                                />
                            </MuiThemeProvider>
                        </>
                    }
                </div>
            </div>
        </Container>
    )
}
export default Register
